import { ErrorStateMatcher } from "@angular/material/core";
import { UntypedFormControl, FormGroupDirective, NgForm } from "@angular/forms";

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: UntypedFormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

export class Annnouncement {
  message: string;
  is_activated: boolean;
  announcement_id: string;
}

export class Vehicle {
  id: string;
  oem: string;
  brand: string;
  nameplate: string;
  globalnameplate: string;
  yearbegin: string;
  yearend: string;
  globalsegment: string;
  architecture: string;
  thirdrowseat: string;
  launchprobability: string;
  ice: boolean | string;
  electric: boolean | string;
  electriconly: boolean | string;
  mildhybrid24volts: boolean | string;
  pluginhybrid: boolean | string;
  extendedrange: boolean | string;
  fuelcell: boolean | string;
  fuelcellplugin: boolean | string;
  active: boolean | string;
  engineeringclass: string;
  driveconfig: string;
  architecturetype: string;
  programcode: string;
  crossvariant: boolean | string;
  crossvariantnameplate: string;
  performance: boolean | string;
  performancenameplate: string;
  created: string;
  createdby: string;
  modified: string;
  modifiedby: string;
  powertrain: string;
  highlights: string;
  autonomousyear: string;
  autonomousdescription: string;
  autonomousprobability: string;
  autonomouslevel: boolean | string;
  isautonomous: boolean;
  photofront: boolean | string;
  photorear: boolean | string;
  photoside: boolean | string;
  photointerior: boolean | string;
  photofronturl: string;
  photorearurl: string;
  photosideurl: string;
  photointeriorurl: string;
  fphotofront: File;
  fphotorear: File;
  fphotoside: File;
  fphotointerior: File;
  attachment: File;
  hybrid: boolean | string;
  propulsion: string;
}

export class Electrification {
  type: string;
  created: string;
  vehicleid: string;
}

export class Cycle {
  bodystyleid: string;
  engineeringcode: string;
  year: any;
  created: string;
  constructor(engineeringcode, year) {
    this.engineeringcode = engineeringcode;
    this.year = year;
  }
}

export class Region {
  bodystyleid: string;
  propulsionid: string;
  region: string;
  regionname: string;
  details: string;
  value: any;
  created: string;
  constructor(id, name, value) {
    this.bodystyleid = id;
    this.propulsionid = id;
    this.region = name;
    this.regionname = name;
    this.value = value;
    this.details = value;
  }
}

export class Propulsion {
  id: string;
  vehicleid: string;
  nameplate: string;
  drivetype: string;
  brand: string;
  type: string;
  dedicated: boolean | string;
  status: string;
  startofproduction: number;
  endofproduction: number;
  bodystyle: string;
  evrangemiles: string;
  motorkw: string;
  energykwh: string;
  charginginfo: string;
  fastcharging: string;
  created: string;
  createdby: string;

  eveparange: string;
  evwltprange: string;
  evcltcrange: string;
}

export enum Messages {
  successRefresh = "Record saved successfully!",
}
